import React, { useEffect, useState } from 'react';
import { fetchInternalNews, fetchInternalNewsBySlug } from '../../http/internalNewsAPI';

const NewsAndUpdates = () => {
    const [newsList, setNewsList] = useState([]);
    const [selectedNews, setSelectedNews] = useState(null);
    const [loading, setLoading] = useState(true);
    const [loadingDetail, setLoadingDetail] = useState(false);
    const [error, setError] = useState("");

    useEffect(() => {
        let mounted = true;

        fetchInternalNews()
            .then((data) => {
                if (!mounted) return;
                setNewsList(Array.isArray(data) ? data : []);
                setError("");
            })
            .catch(() => {
                if (!mounted) return;
                setError("Failed to load news");
            })
            .finally(() => {
                if (mounted) setLoading(false);
            });

        return () => {
            mounted = false;
        };
    }, []);

    const handleSelectNews = (news) => {
        setLoadingDetail(true);
        setError("");

        fetchInternalNewsBySlug(news.slug)
            .then((data) => setSelectedNews(data))
            .catch(() => setError("Failed to load news"))
            .finally(() => setLoadingDetail(false));
    };

    if (selectedNews) {
        return (
            <div>
                <button className="btn btn-sm btn-outline-secondary mb-3" onClick={() => setSelectedNews(null)}>
                    ← Back to News
                </button>

                <h5>{selectedNews.title}</h5>
                <p className="text-muted fst-italic">{selectedNews.date}</p>

                <div>
                    <img
                        src={selectedNews.image}
                        alt={selectedNews.title}
                        style={{
                            float: 'left',
                            width: '20%',
                            maxWidth: '150px',
                            maxHeight: '150px',
                            objectFit: 'cover',
                            borderRadius: '8px',
                            marginRight: '20px',
                            marginBottom: '10px'
                        }}
                    />

                    <div
                        className="text-muted small"
                        style={{
                            lineHeight: '1.4'
                        }}
                        dangerouslySetInnerHTML={{ __html: selectedNews.content }}
                    />
                </div>

                <div className="clearfix" />
            </div>



        );
    }

    return (
        <div>
            <h5>News & Updates</h5>
            {loading && <p className="small text-muted mb-2">Loading news...</p>}
            {loadingDetail && <p className="small text-muted mb-2">Loading news...</p>}
            {error && <p className="small text-danger mb-2">{error}</p>}
            {!loading && !error && newsList.length === 0 && (
                <p className="small text-muted mb-0">No news yet.</p>
            )}
            <ul className="list-group">
                {newsList.map((news) => (
                    <li
                        key={news.id}
                        className="list-group-item list-group-item-action"
                        onClick={() => handleSelectNews(news)}
                        style={{ cursor: 'pointer' }}
                    >
                        <div className="clearfix">
                            <img
                                src={news.image}
                                alt={news.title}
                                style={{
                                    float: 'left',
                                    width: '20%',
                                    maxWidth: '90px',
                                    maxHeight: '90px',
                                    objectFit: 'cover',
                                    borderRadius: '4px',
                                    marginRight: '10px',
                                    marginBottom: '6px',
                                    flexShrink: 0
                                }}
                            />
                            <div>
                                <h6 className="mb-0">{news.title}</h6>
                                <small className="text-muted small fst-italic">{news.date}</small>
                                <p className="small text-muted mb-0">{news.summary}</p>
                            </div>
                        </div>
                    </li>
                ))}
            </ul>

        </div>
    );
};

export default NewsAndUpdates;
